document.addEventListener('DOMContentLoaded', function() {

  // swiper
  const swiper = new Swiper(".swiper", {
    loop: true,
    spaceBetween: 16,
    autoplay: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1.5,
    breakpoints: {
      500: {
        slidesPerView: 2.5,
        spaceBetween: 24,
      }
    },
  });
});